/* eslint-disable @typescript-eslint/indent */

/* Note: please be careful with indentation, we have the rule disabled because of
*  eslint not being able to properly indent js inside styled components
*/

// Libraries
import styled from 'styled-components';

// Types
import { SolenoidStatus } from '../../../../../../../../types/crusher';
import { Theme } from '../../../../../../../../types/theme';

/**
 * Map the solenoid status to the color
 * @param status should receive a SolenoidStatus
 * @param theme should receive the theme object
 * @returns the color of the solenoid status
*/
const getSolenoidStatusColor = (
  status: SolenoidStatus,
  theme: Theme,
): string => {
  const colorMap: Record<SolenoidStatus, string> = {
    [SolenoidStatus.success]:
      theme.color.crusherDashboard.maintenance.comboUnit.valveBank.solenoidSuccessColor,
    [SolenoidStatus.fault]:
      theme.color.crusherDashboard.maintenance.comboUnit.valveBank.solenoidFaultColor,
    [SolenoidStatus.disabled]:
      theme.color.crusherDashboard.maintenance.comboUnit.valveBank.solenoidDisabledColor,
    [SolenoidStatus.disconnected]:
      theme.color.crusherDashboard.maintenance.comboUnit.valveBank.solenoidDisconnectedColor,
  };

  return colorMap[status];
};

export const Container = styled.div`
  width: 100%;
  height: 100%;
`;

export const ContentContainer = styled.div`
  display: flex;
  height: 100%;
`;

export const LeftPanel = styled.div`
  min-width: 400px;
  min-width: 30%;
  display: flex;
`;

export const RightPanel = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const SolenoidStatusContainer = styled.div`
  border-radius: 4px 0 0 4px;
  width: 100%;
  padding: 20px 20px 20px 15px;
  background-color: ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.valveBank.backgroundColor};
  border-top: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.valveBank.borderColor};
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.valveBank.borderColor};
  border-left: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.valveBank.borderColor};
`;

export const SolenoidStatusTitle = styled.div`
  margin: 0 0 12px 0;
  display: grid;
  grid-template-columns: 5fr repeat(8, 1fr);
  gap: 2px;
  align-items: center;
`;

export const TitleSection = styled.div`
  display: flex;
  align-items: center;
  grid-column: 1;
  color: ${({ theme }) => theme.color.crusherDashboard.maintenance.comboUnit.valveBank.titleColor};
`;

export const NumberedHeader = styled.div`
  display: contents;
`;

export const NumberedCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  grid-column: span 1;
  min-width: 0;
  color: ${({ theme }) => theme.color.crusherDashboard.maintenance.comboUnit.valveBank.titleColor};
`;

export const SolenoidTable = styled.div`
  width: 100%;
`;

export const SolenoidTableHeader = styled.div`
  display: grid;
  grid-template-columns: 4fr repeat(8, 1fr);
  gap: 8px;
  align-items: center;
  padding-bottom: 12px;
  margin-bottom: 8px;
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.valveBank.itemBorderColor};
`;

export const SolenoidTableRow = styled.div`
  display: grid;
  grid-template-columns: 5fr repeat(8, 1fr);
  gap: 2px;
  align-items: center;
  height: 46px;
  border-bottom: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.valveBank.itemBorderColor};
`;

export const SolenoidFunctionCell = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  padding-right: 8px;
`;

export const SolenoidStatusCell = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 4px;
  min-width: 0;
`;

export const SolenoidStatusDot = styled.div<{
  status: SolenoidStatus;
}>`
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: ${({ status, theme }) => getSolenoidStatusColor(status, theme)};
  transition: all 0.2s ease-in-out;
`;

export const ComboUnitImageContainer = styled.div`
  border-radius: 0 4px 4px 0;
  position: relative;
  border: 1px solid ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.valveBank.imageContainerBorderColor};
  width: 100%;
  height: 100%;
  padding: 20px;
  background: ${({
    theme,
  }) => theme.color.crusherDashboard.maintenance.comboUnit.valveBank.imageContainerBackgroundColor};
`;

export const ComboUnitImageStyled = styled.img<{ isHovered: boolean }>`
  width: 100%;
  flex: 1;
  align-items: center;
  justify-content: center;
  object-fit: scale-down;
  height: calc(100vh - 300px);
  transition: all 0.3s ease;
  transform: ${({ isHovered }) => (isHovered ? 'scale(1.02)' : 'scale(1)')};
  filter: ${({ isHovered }) => (isHovered ? 'brightness(1.05)' : 'brightness(1)')};
`;
